import { useTranslation } from 'react-i18next'
import SubHeaders from '@/components/Headers/SubHeaders'
import { paths } from '@/utils/path'
import NavigationCards from '../NavigationCards'
import ComingSoon from '@/components/ComingSoon'

const PasswordSecurity = () => {
    const { t } = useTranslation()

    return (
        <div>
            <SubHeaders
                actions={[]}
                breadcrumbs={[
                    { path: paths.account, title: t('account') },
                    { path: '', title: t('account-passwork-security') },
                ]}
            />

            <NavigationCards>
                <ComingSoon
                    featureName="account-passwork-security"
                    description="enhanced-security-coming-soon"
                    showBackButton={false}
                />
            </NavigationCards>
        </div>
    )
}

export default PasswordSecurity
